export const Environments = {
  Production: 'production',
  Demo: 'demo-production',
  Staging: 'staging',
  Development: 'development',
  Local: 'local',
} as const;

export type Environment = (typeof Environments)[keyof typeof Environments];

export const getEnvironment = (): Environment => {
  return (process.env.APP_ENVIRONMENT as Environment) ?? Environments.Local;
};

export function isTestEnvironment() {
  return process.env.NODE_ENV === 'test';
}

export function isBuildDevelopment() {
  return process.env.NODE_ENV === 'development';
}

export function isProductionOrDemoEnvironment() {
  const env = getEnvironment();
  return env === Environments.Production || env === Environments.Demo;
}

export function isProductionLikeEnvironment() {
  const env = getEnvironment();
  return (
    env === Environments.Production ||
    env === Environments.Demo ||
    env === Environments.Staging
  );
}

export const getSentryEnvironment = (): Environment | undefined => {
  const environment = getEnvironment();

  if (environment === Environments.Local) {
    return undefined;
  }

  return environment;
};

export function isSentryEnabled(): boolean {
  return isProductionLikeEnvironment();
}
